import {
  IconButton,
  IContextualMenuProps,
  PrimaryButton,
  Stack,
} from '@fluentui/react';
import React, { useEffect, useState } from 'react';
import { FlowApproval_Query } from 'settings/account/intuitiveApprovalSetupFlow/__generated__/FlowApproval';
import { ApprovalTestResults_approvalTestResults_nodes } from '../__generated__/ApprovalTestResults';
import { DeleteTest } from '../delete';
import { FormView } from './FormView';
import { AttachTestGroup } from './AttachTestGroup';

export const ApprovalTestView: React.FC<{
  approvalDetailsData: FlowApproval_Query | undefined;
  onRefresh: () => void;
  testCaseSelected: string | undefined;
  setTestCaseSelected: React.Dispatch<React.SetStateAction<string | undefined>>;
  onClose: () => void;
  onSubmitComplete: (id: string | null | undefined) => void;
  selectedList: ApprovalTestResults_approvalTestResults_nodes[];
}> = ({
  approvalDetailsData,
  onRefresh,
  testCaseSelected,
  setTestCaseSelected,
  onClose,
  onSubmitComplete,
  selectedList,
}) => {
  const [panelVisible, setPanelVisible] = useState(false);
  const [attachGroup, setAttachGroup] = useState(false);

  useEffect(() => {
    if (!panelVisible && testCaseSelected) {
      setPanelVisible(true);
    }
  }, [panelVisible, testCaseSelected]);

  const menuProps: IContextualMenuProps = {
    items: [
      {
        key: 'testGroups',
        text: 'Test Groups',
        onClick: () => {
          setAttachGroup(true);
        },
      },
    ],
  };
  return (
    <Stack horizontal tokens={{ childrenGap: 10 }}>
      {selectedList && approvalDetailsData?.approval?.id && (
        <DeleteTest
          selectedList={selectedList}
          approvalId={approvalDetailsData?.approval?.id}
        />
      )}
      <PrimaryButton
        text="New Test"
        split
        menuProps={menuProps}
        onClick={() => {
          setPanelVisible(true);
        }}
      />

      <FormView
        onSubmitComplete={onSubmitComplete}
        onRefresh={onRefresh}
        testCaseSelected={testCaseSelected}
        setTestCaseSelected={setTestCaseSelected}
        approvalDetailsData={approvalDetailsData}
        panelVisible={panelVisible}
        onClose={() => {
          onClose();
          setPanelVisible(false);
        }}
      />
      {!!approvalDetailsData?.approval?.id && attachGroup && (
        <AttachTestGroup
          onClose={() => {
            setAttachGroup(false);
          }}
          approvalId={approvalDetailsData?.approval?.id}
        />
      )}
    </Stack>
  );
};
